/**
 * Custom Audio Player
 * Handles play/pause, timer, and slider functionality
 */
document.addEventListener('DOMContentLoaded', function () {
  // Initialize all audio players
  const audioPlayers = document.querySelectorAll('.js-audio-player');

  audioPlayers.forEach(playerContainer => {
    const audioElement = playerContainer.querySelector('audio');
    const playButton = playerContainer.querySelector('.js-audio-play');
    const playIcon = playerContainer.querySelector('.js-audio-play-icon');
    const pauseIcon = playerContainer.querySelector('.js-audio-pause-icon');
    const timerCurrent = playerContainer.querySelector(
      '.js-audio-timer-current'
    );
    const timerTotal = playerContainer.querySelector('.js-audio-timer-total');
    const sliderInput = playerContainer.querySelector('.js-audio-slider-input');
    const sliderProgress = playerContainer.querySelector(
      '.js-audio-slider-progress'
    );

    if (!audioElement || !playButton || !sliderInput) {
      return;
    }

    // Format time to MM:SS
    function formatTime(seconds) {
      if (isNaN(seconds) || !isFinite(seconds)) {
        return '00:00';
      }
      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    }

    // Update timer display
    function updateTimer() {
      if (timerCurrent) {
        timerCurrent.textContent = formatTime(audioElement.currentTime);
      }
      if (timerTotal) {
        timerTotal.textContent = formatTime(audioElement.duration);
      }
    }

    // Update slider position
    function updateSlider() {
      if (audioElement.duration) {
        const percentage =
          (audioElement.currentTime / audioElement.duration) * 100;
        sliderInput.value = percentage;
        if (sliderProgress) {
          sliderProgress.style.width = `${percentage}%`;
        }
      }
    }

    // Update play/pause button state
    function updatePlayButton() {
      const playLabel = window.spiceAudioPlayer?.play || 'Play';
      const pauseLabel = window.spiceAudioPlayer?.pause || 'Pause';

      if (audioElement.paused) {
        if (playIcon) playIcon.style.display = 'block';
        if (pauseIcon) pauseIcon.style.display = 'none';
        if (playButton) {
          playButton.setAttribute('aria-label', playLabel);
        }
      } else {
        if (playIcon) playIcon.style.display = 'none';
        if (pauseIcon) pauseIcon.style.display = 'block';
        if (playButton) {
          playButton.setAttribute('aria-label', pauseLabel);
        }
      }
    }

    // Play/Pause button click handler
    playButton.addEventListener('click', function () {
      if (audioElement.paused) {
        audioElement.play();
      } else {
        audioElement.pause();
      }
    });

    // Slider input handler
    sliderInput.addEventListener('input', function () {
      if (audioElement.duration) {
        const seekTime = (sliderInput.value / 100) * audioElement.duration;
        audioElement.currentTime = seekTime;
        if (sliderProgress) {
          sliderProgress.style.width = `${sliderInput.value}%`;
        }
      }
    });

    // Audio event listeners
    audioElement.addEventListener('loadedmetadata', function () {
      updateTimer();
      updateSlider();
    });

    audioElement.addEventListener('timeupdate', function () {
      updateTimer();
      updateSlider();
    });

    audioElement.addEventListener('play', function () {
      updatePlayButton();
    });

    audioElement.addEventListener('pause', function () {
      updatePlayButton();
    });

    audioElement.addEventListener('ended', function () {
      audioElement.currentTime = 0;
      updatePlayButton();
      updateSlider();
    });

    // Initialize display
    updateTimer();
    updatePlayButton();
  });
});
